import React, { PureComponent } from 'react';
import 'semantic-ui-css/components/icon.min.css';
const icon = "https://cdn.obsess-vr.com/umg/Interscope_Records_v2.png"
class LoadingIcon extends PureComponent {
    render() {
        return (
            <img className='custom-loading-icon' src={icon} width={50} height={50} />
        );
    }
}

export default LoadingIcon;
